import React, { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './chatbotui.css';
import botIcon from '../../assets/img/asistente.png';
import { FaArrowUp, FaFileExcel, FaChartLine, FaSpinner, FaLightbulb, FaGlobe, FaGlobeAmericas, FaPaperclip, FaTimes } from 'react-icons/fa';
import * as XLSX from 'xlsx';
import { useAuthenticator } from '@aws-amplify/ui-react';
import Modal from 'react-modal';
import 'chart.js/auto';
import ChartWithControls from '../chatbotui/chartwithcontrols';
import DataTable from './datatable';
import { BedrockAgentRuntimeClient, InvokeAgentCommand } from "@aws-sdk/client-bedrock-agent-runtime";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import { fetchAuthSession } from 'aws-amplify/auth';
import config from '../../amplifyconfiguration.json';
import { SignatureV4 } from "@aws-sdk/signature-v4";
import { HttpRequest } from "@aws-sdk/protocol-http";
import { Sha256 } from "@aws-crypto/sha256-browser";
import { v4 as uuidv4 } from 'uuid';
import { FaEllipsisV, FaBookmark } from 'react-icons/fa';
import SQLValidator from '../../utils/SQLValidator';
import {
    buildWebSearchPrompt, buildSuggestedQuestionsPrompt, buildConsultClaudePrompt, buildSQLPrompt, buildSQLCorrectionPrompt
} from '../../utils/prompts';
import { streamQuery } from '../../utils/backendClient';
import { generateVisualizationSQL } from '../../utils/vizClient';

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { tomorrow } from 'react-syntax-highlighter/dist/esm/styles/prism';
import FileUploader from '../FileUploader/FileUploader';


const Chatbotui = ({ isSidebarVisible }) => {

    const { id_conversation } = useParams();
    const [response, setResponse] = useState("");
    const { user } = useAuthenticator((context) => [context.user]);
    const id_user = user.username
    const [message, setMessage] = useState('');
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [queryData, setQueryData] = useState(null);
    const messageInputRef = useRef(null);
    const messagesEndRef = useRef(null);
    const [loadingMessage, setLoadingMessage] = useState('Analyzing price trends...');

    const [webSearchEnabled, setWebSearchEnabled] = useState(false);
    const [webSearchLoading, setWebSearchLoading] = useState(false);

    const [vizLoading, setVizLoading] = useState({});
    const [vizData, setVizData] = useState({});

    const [activeOptionsMenu, setActiveOptionsMenu] = useState(null);
    const [savingConsult, setSavingConsult] = useState(false);

    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [imageModeEnabled, setImageModeEnabled] = useState(false);
    const imageInputRef = useRef(null);

    const [hoverButtonIndex, setHoverButtonIndex] = useState(null);

    const [suggestedQuestions, setSuggestedQuestions] = useState([
        "¿Cuáles son las tendencias de ventas por zona geográfica en los últimos 6 meses?",
        "¿Qué productos tienen mejor margen de ganancia por categoría?",
        "¿Cómo se distribuyen las ventas entre mis tiendas y la competencia por ciudad?"
    ]);

    const [loadingSuggestions, setLoadingSuggestions] = useState(false);

    // 🎯 AGENTE TYPE: 'subnacional' o 'nacional'
    const [agentType, setAgentType] = useState('subnacional');

    // 💭 THINKING MESSAGES STATE
    const [thinkingMessage, setThinkingMessage] = useState('');
    const [showThinking, setShowThinking] = useState(false);

    // 📁 FILE UPLOAD STATE
    const [uploadedFile, setUploadedFile] = useState(null);
    const [fileClearTrigger, setFileClearTrigger] = useState(null);

    // 🔥 REFS PARA STREAMING
    const streamingBufferRef = useRef('');
    const animationFrameRef = useRef(null);
    const isStreamingRef = useRef(false);
    const currentLoadingPhraseRef = useRef('');

    // 🔥 NUEVO: Cache de queries SQL
    const sqlCacheRef = useRef(new Map());

    const baseURL = process.env.REACT_APP_BASE_URL;
    const baseURLBD = process.env.REACT_APP_BD;
    const endpoint_mes = '/get_messages_conversation';
    const endpoint_add_message = '/add_message';
    const endpoint_get_sql = '/get_query';
    const endpoint_executeSQL = '/get_rds';

    // Agente principal para respuestas del chat
    const MAIN_AGENT_ID = "UYF7CEYBIB";
    const MAIN_AGENT_ALIAS_ID = "KGUVP9419C";

    // Agente especializado para generación de SQL y visualización
    const SQL_AGENT_ID = "UYF7CEYBIB";
    const SQL_AGENT_ALIAS_ID = "9HU2GXHMZD";

    const endpoint_add_saved_consult = '/add_saved_consult';

    const loadingPhrases = [
        "Without data, you're just another person with an opinion. – W. Edwards Deming",
        "In the end, we are all determined by data. – Tim O'Reilly",
        "In God we trust. All others must bring data. – W. Edwards Deming",
        "Data is the new oil. – Clive Humby",
        "The goal is to turn data into information, and information into insight. – Carly Fiorina",
        "Numbers have an important story to tell. They rely on you to give them a clear and convincing voice. – Stephen Few",
        "Torture the data, and it will confess to anything. – Ronald Coase",
        "Data beats emotions. – Sean Rad",
        "You can have data without information, but you cannot have information without data. – Daniel Keys Moran",
        "Big data is at the foundation of all the megatrends that are happening today. – Chris Lynch",
        "Information is the oil of the 21st century, and analytics is the combustion engine. – Peter Sondergaard",
        "The world is one big data problem. – Andrew McAfee",
        "Data is a precious thing and will last longer than the systems themselves. – Tim Berners-Lee",
        "If you torture the data long enough, it will confess to anything. – Darrell Huff",
        "The most valuable commodity I know of is information. – Gordon Gekko (Wall Street)",
        "Data really powers everything that we do. – Jeff Weiner",
    ];

    /* --------------- ---------------  ---------------  Interfaz  ---------------  --------------- --------------- */

    const handleOptionsClick = (index, e) => {
        e.stopPropagation();
        setActiveOptionsMenu(activeOptionsMenu === index ? null : index);
    };

    useEffect(() => {
        const handleClickOutside = () => {
            setActiveOptionsMenu(null);
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        return () => {
            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current);
            }
        };
    }, []);

    useEffect(() => {
        const intervalId = setInterval(() => {
            // Solo actualizar si hay mensajes temporales
            setMessages(prevMessages => {
                const hasTempMessages = prevMessages.some(msg => msg.temp && !isStreamingRef.current);

                if (!hasTempMessages) {
                    return prevMessages; // No cambiar el array si no hay mensajes temporales
                }

                const randomIndex = Math.floor(Math.random() * loadingPhrases.length);
                const newPhrase = loadingPhrases[randomIndex];
                currentLoadingPhraseRef.current = newPhrase;

                return prevMessages.map(msg =>
                    msg.temp && !isStreamingRef.current ? {
                        ...msg,
                        content: <span className="thinking-dots">{newPhrase}</span>
                    } : msg
                );
            });
        }, 4000);

        return () => clearInterval(intervalId);
    }, [loadingPhrases]);

    useEffect(() => {
        return () => {
            if (imagePreview) {
                URL.revokeObjectURL(imagePreview);
            }
        };
    }, [imagePreview]);

    const adjustTextareaHeight = (element) => {
        element.style.height = 'auto';
        element.style.height = (element.scrollHeight) + 'px';
    };

    const handleTextareaChange = (e) => {
        setMessage(e.target.value);
        adjustTextareaHeight(e.target);
    };

    const addMessage = (author, content, type = 'text', data = null, temp = false) => {
        const newMessage = { author, content, type, data, id: Date.now(), temp };
        setMessages(prevMessages => [...prevMessages, newMessage]);
    };

    const scrollToBottom = () => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    useEffect(() => {
        const fetchMessages = async () => {
            if (id_conversation) {
                try {
                    const authenticatedRequest = await createAuthenticatedRequest(config);
                    const url = `${baseURL}${endpoint_mes}?id_conversation=${encodeURIComponent(id_conversation)}`;
                    const response = await authenticatedRequest(url, 'GET', null);

                    if (response && response.messages) {
                        const sortedMessages = response.messages.sort((a, b) => {
                            return new Date(a.created_at || a.timestamp || 0) - new Date(b.created_at || b.timestamp || 0);
                        });
                        setMessages(sortedMessages);
                        setTimeout(scrollToBottom, 100);
                    } else {
                        console.warn('No messages data in response:', response);
                        setMessages([]);
                    }
                } catch (error) {
                    console.error('Error fetching messages:', error);
                    setMessages([]);
                }
            }
        };

        fetchMessages();
    }, [id_conversation, config]);

    useEffect(() => {
        if (messages.length > 0) {
            scrollToBottom();
        }
    }, [messages.length]);

    useEffect(() => {
        const handleSavedQueryEvent = (event) => {
            const { query } = event.detail;
            setMessage(query);

            setTimeout(() => {
                const textarea = messageInputRef.current || document.querySelector('.message-input');
                if (textarea) {
                    textarea.style.height = 'auto';
                    textarea.style.height = (textarea.scrollHeight) + 'px';
                    textarea.focus();
                }
            }, 50);
        };

        document.addEventListener('savedQuerySelected', handleSavedQueryEvent);

        return () => {
            document.removeEventListener('savedQuerySelected', handleSavedQueryEvent);
        };
    }, []);

    useEffect(() => {
        const handleDirectInputChange = (event) => {
            if (event.target.matches('.message-input')) {
                setMessage(event.target.value);
            }
        };

        document.addEventListener('input', handleDirectInputChange);

        return () => {
            document.removeEventListener('input', handleDirectInputChange);
        };
    }, []);

    const handleButtonMouseEnter = (index) => {
        setHoverButtonIndex(index);
    };

    const handleButtonMouseLeave = () => {
        setHoverButtonIndex(null);
    };

    const useDraggableCarousel = () => {
        const carouselRef = useRef(null);
        const isDragging = useRef(false);
        const startX = useRef(0);
        const scrollLeft = useRef(0);

        const handleMouseDown = (e) => {
            if (!carouselRef.current) return;
            isDragging.current = true;
            startX.current = e.pageX - carouselRef.current.offsetLeft;
            scrollLeft.current = carouselRef.current.scrollLeft;
            carouselRef.current.style.cursor = 'grabbing';
        };

        const handleMouseUp = () => {
            if (!carouselRef.current) return;
            isDragging.current = false;
            carouselRef.current.style.cursor = 'grab';
        };

        const handleMouseLeave = () => {
            if (isDragging.current) {
                isDragging.current = false;
                if (carouselRef.current) {
                    carouselRef.current.style.cursor = 'grab';
                }
            }
        };

        const handleMouseMove = (e) => {
            if (!isDragging.current || !carouselRef.current) return;
            e.preventDefault();
            const x = e.pageX - carouselRef.current.offsetLeft;
            const walk = (x - startX.current) * 1.5;
            carouselRef.current.scrollLeft = scrollLeft.current - walk;
        };

        const handleTouchStart = (e) => {
            if (!carouselRef.current) return;
            isDragging.current = true;
            startX.current = e.touches[0].pageX - carouselRef.current.offsetLeft;
            scrollLeft.current = carouselRef.current.scrollLeft;
        };

        const handleTouchMove = (e) => {
            if (!isDragging.current || !carouselRef.current) return;
            const x = e.touches[0].pageX - carouselRef.current.offsetLeft;
            const walk = (x - startX.current) * 1.5;
            carouselRef.current.scrollLeft = scrollLeft.current - walk;
        };

        const handleTouchEnd = () => {
            isDragging.current = false;
        };

        useEffect(() => {
            const carousel = carouselRef.current;
            if (!carousel) return;

            let isDown = false;
            let startX;
            let scrollLeft;

            const mouseDown = (e) => {
                isDown = true;
                carousel.style.cursor = 'grabbing';
                startX = e.pageX - carousel.offsetLeft;
                scrollLeft = carousel.scrollLeft;
            };

            const mouseUp = () => {
                isDown = false;
                carousel.style.cursor = 'grab';
            };

            const mouseLeave = () => {
                isDown = false;
                carousel.style.cursor = 'grab';
            };

            const mouseMove = (e) => {
                if (!isDown) return;
                e.preventDefault();
                const x = e.pageX - carousel.offsetLeft;
                const walk = (x - startX) * 1.5;
                carousel.scrollLeft = scrollLeft - walk;
            };

            const touchStart = (e) => {
                isDown = true;
                startX = e.touches[0].pageX - carousel.offsetLeft;
                scrollLeft = carousel.scrollLeft;
            };

            const touchMove = (e) => {
                if (!isDown) return;
                const x = e.touches[0].pageX - carousel.offsetLeft;
                const walk = (x - startX) * 1.5;
                carousel.scrollLeft = scrollLeft - walk;
            };

            const touchEnd = () => {
                isDown = false;
            };

            carousel.addEventListener('mousedown', mouseDown);
            carousel.addEventListener('mouseup', mouseUp);
            carousel.addEventListener('mouseleave', mouseLeave);
            carousel.addEventListener('mousemove', mouseMove);

            carousel.addEventListener('touchstart', touchStart);
            carousel.addEventListener('touchmove', touchMove);
            carousel.addEventListener('touchend', touchEnd);

            return () => {
                carousel.removeEventListener('mousedown', mouseDown);
                carousel.removeEventListener('mouseup', mouseUp);
                carousel.removeEventListener('mouseleave', mouseLeave);
                carousel.removeEventListener('mousemove', mouseMove);

                carousel.removeEventListener('touchstart', touchStart);
                carousel.removeEventListener('touchmove', touchMove);
                carousel.removeEventListener('touchend', touchEnd);
            };
        }, [suggestedQuestions]);

        return carouselRef;
    };
    const carouselRef = useDraggableCarousel();

    const handleSuggestedQuestion = (question) => {
        setMessage(question);
        if (messageInputRef.current) {
            messageInputRef.current.focus();
            adjustTextareaHeight(messageInputRef.current);
        }
    };

    const toggleWebSearch = () => {
        setWebSearchEnabled(!webSearchEnabled);
    };

    const handleImageChange = (e) => {
        const file = e.target.files?.[0];
        if (file) {
            if (!file.type.startsWith('image/')) {
                alert('Por favor selecciona un archivo de imagen válido.');
                return;
            }

            if (file.size > 10 * 1024 * 1024) {
                alert('El archivo es demasiado grande. Máximo 10MB.');
                return;
            }

            if (imagePreview) {
                URL.revokeObjectURL(imagePreview);
            }

            setImageFile(file);
            setImagePreview(URL.createObjectURL(file));
            setImageModeEnabled(true);
            messageInputRef.current?.focus();
        }
    };

    const clearImage = () => {
        if (imagePreview) {
            URL.revokeObjectURL(imagePreview);
        }

        setImageFile(null);
        setImagePreview(null);
        setImageModeEnabled(false);

        if (imageInputRef.current) {
            imageInputRef.current.value = '';
        }
    };

    // 📁 FILE UPLOAD HANDLER
    const handleFileUpload = (fileData) => {
        setUploadedFile(fileData);
        if (fileData) {
            console.log('[ChatBot] 📁 Archivo cargado:', fileData.filename, '| Tipo:', fileData.type);
        } else {
            console.log('[ChatBot] 🗑️ Archivo eliminado');
        }
    };

    /* ---------------  ---------------  --------------- Funciones de mensajes BD ---------------  ---------------  --------------- */

    // 🔥 NUEVA FUNCIÓN: Genera SQL y lo valida ejecutándolo
    const generateAndValidateSQL = async (
        mensajes_anteriores,
        userContent,
        botContent,
        maxRetries = 2
    ) => {
        const CLAUDE_API_KEY = "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";

        // 🔥 Cache check
        const cacheKey = `${userContent}_${botContent}`;
        if (sqlCacheRef.current.has(cacheKey)) {
            //console.log('💾 SQL válido encontrado en cache');
            return sqlCacheRef.current.get(cacheKey);
        }

        const mensajes_form = mensajes_anteriores.map(({ question, query }) => ({ question, query }));
        let conversationHistory = []; // Historial de la conversación con Claude

        for (let attempt = 1; attempt <= maxRetries; attempt++) {
            try {
                //console.log(`🔄 Intento ${attempt}/${maxRetries}`);

                // 🔥 Construir prompt (incluye errores previos si existen)
                let prompt;
                if (attempt === 1) {
                    // Primera vez: prompt normal
                    prompt = buildSQLPrompt(userContent, safeJSONStringify(mensajes_form));
                } else {
                    // Reintentos: incluir error de PostgreSQL
                    const lastError = conversationHistory[conversationHistory.length - 1];
                    prompt = buildSQLCorrectionPrompt(
                        userContent,
                        safeJSONStringify(mensajes_form),
                        lastError.sql,
                        lastError.error
                    );
                }

                // 🔥 Generar SQL con Claude API
                //console.log(`📡 Generando SQL con Claude (intento ${attempt})...`);

                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), 10000);

                const response = await fetch("https://api.anthropic.com/v1/messages", {
                    method: "POST",
                    headers: {
                        "x-api-key": CLAUDE_API_KEY,
                        "anthropic-version": "2023-06-01",
                        "content-type": "application/json",
                        "anthropic-dangerous-direct-browser-access": "true"
                    },
                    body: JSON.stringify({
                        model: "claude-sonnet-4-20250514",
                        max_tokens: 1500,
                        temperature: 0,
                        messages: [{ role: "user", content: prompt }]
                    }),
                    signal: controller.signal
                });

                clearTimeout(timeoutId);

                if (!response.ok) {
                    throw new Error(`Claude API error: ${response.status}`);
                }

                const data = await response.json();
                let sqlQuery = data.content[0]?.text || "";

                if (!sqlQuery || sqlQuery.trim().length === 0) {
                    throw new Error("Claude devolvió respuesta vacía");
                }

                // 🔥 Limpiar SQL
                sqlQuery = enhancedCleanSQL(sqlQuery);
                //console.log(`📝 SQL generado (intento ${attempt}):`, sqlQuery.substring(0, 150));

                // 🔥 Validar que sea SQL válido
                if (!sqlQuery.match(/\b(SELECT|WITH)\b/i)) {
                    throw new Error("No es SQL válido");
                }

                // 🔥 VALIDACIÓN REAL: Ejecutar en PostgreSQL
                //console.log(`🚀 Ejecutando SQL en PostgreSQL (intento ${attempt})...`);
                const executionResult = await executeSQL(sqlQuery);

                // 🔥 Analizar resultado de ejecución
                if (executionResult.error) {
                    // SQL falló - guardar error para próxima iteración
                    const pgError = executionResult.error;
                    console.error(`❌ PostgreSQL error (intento ${attempt}):`, pgError);

                    conversationHistory.push({
                        attempt: attempt,
                        sql: sqlQuery,
                        error: pgError
                    });

                    // Si es el último intento, lanzar error
                    if (attempt === maxRetries) {
                        throw new Error(`SQL falló después de ${maxRetries} intentos. Último error: ${pgError}`);
                    }

                    // Continuar al siguiente intento
                    //console.log(`🔄 Reintentando con corrección del error...`);
                    continue;
                }

                // 🔥 Validar que hay datos en la respuesta
                if (!executionResult.data || !Array.isArray(executionResult.data)) {
                    throw new Error("Formato de respuesta inválido");
                }

                // ✅ SQL FUNCIONA - Guardar en cache y retornar
                //console.log(`✅ SQL validado exitosamente (intento ${attempt})`);
                //console.log(`📊 Datos obtenidos: ${executionResult.data.length} filas`);

                const result = {
                    sql: sqlQuery,
                    data: executionResult.data,
                    columns: executionResult.columns,
                    column_types: executionResult.column_types,
                    attempts: attempt,
                    success: true
                };

                // Guardar en cache
                sqlCacheRef.current.set(cacheKey, result);

                return result;

            } catch (error) {
                console.error(`❌ Error en intento ${attempt}:`, error.message);

                // Si es el último intento, retornar error
                if (attempt === maxRetries) {
                    return {
                        sql: conversationHistory.length > 0
                            ? conversationHistory[conversationHistory.length - 1].sql
                            : "",
                        error: error.message,
                        attempts: attempt,
                        success: false,
                        conversationHistory: conversationHistory
                    };
                }

                // Pequeño delay antes de reintentar
                await new Promise(resolve => setTimeout(resolve, 500));
            }
        }
    };

    const handleSaveConsult = async (content) => {
        try {
            setSavingConsult(true);
            const authenticatedRequest = await createAuthenticatedRequest(config);
            const url = `${baseURL}${endpoint_add_saved_consult}`;

            const response = await authenticatedRequest(
                url,
                'POST',
                {
                    id_user: id_user,
                    consult: content
                }
            );

            if (response && response.id_saved) {
                const customEvent = new CustomEvent('querySaved', {
                    detail: { id_saved: response.id_saved },
                    bubbles: true,
                    cancelable: true
                });
                document.dispatchEvent(customEvent);

                setActiveOptionsMenu(null);
            } else {
                throw new Error("No se recibió confirmación del servidor");
            }
        } catch (error) {
            console.error("Error al guardar la consulta:", error);
        } finally {
            setSavingConsult(false);
        }
    };

    const addMessageBD = async (id_conversation, id_user, message, author, id_message) => {
        try {
            const authenticatedRequest = await createAuthenticatedRequest(config);
            const url = `${baseURL}${endpoint_add_message}`;

            const response = await authenticatedRequest(
                url,
                'POST',
                {
                    id_user: id_user,
                    id_conversation: id_conversation,
                    content: message,
                    author: author,
                    id_message: id_message
                }
            );

            return response.id_message

        } catch (error) {
            console.error('Error creating new conversation:', error);
            return "None"
        }
    };

    const updateMessageBD = async (id_message, query_sql) => {
        try {
            const authenticatedRequest = await createAuthenticatedRequest(config);
            const url = `${baseURL}/update_query_sql`;

            const response = await authenticatedRequest(
                url,
                'POST',
                {
                    id_message: id_message,
                    query_sql: query_sql
                }
            );

            return response.message;

        } catch (error) {
            console.error('Error updating query_sql:', error);
            return "Failed to update query_sql";
        }
    };

    /* ---------------  ---------------  --------------- Funciones complementarias (Web, imágenes, preguntas sugeridas, errores)  ---------------  --------------- --------------- */

    const performWebSearch = async (query) => {
        const apiKey = "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";

        try {
            setWebSearchLoading(true);

            const content = buildWebSearchPrompt(query);

            const response = await fetch("https://api.anthropic.com/v1/messages", {
                method: "POST",
                headers: {
                    "x-api-key": apiKey,
                    "anthropic-version": "2023-06-01",
                    "content-type": "application/json",
                    "anthropic-dangerous-direct-browser-access": "true"
                },
                body: JSON.stringify({
                    model: "claude-sonnet-4-20250514",
                    max_tokens: 1500,
                    tools: [
                        {
                            type: "web_search_20250305",
                            name: "web_search",
                            max_uses: 3,
                            user_location: {
                                type: "approximate",
                                city: "Mexico City",
                                region: "Ciudad de Mexico",
                                country: "MX",
                                timezone: "America/Mexico_City"
                            }
                        }
                    ],
                    messages: [
                        {
                            role: "user",
                            content: content
                        }
                    ]
                })
            })
                .then((response) => {
                    if (!response.ok) {
                        console.error('Error en la API de Claude:', response.statusText);
                        return null;
                    }
                    return response.json();
                })
                .then((data) => {
                    if (!data || !data.content || data.content.length === 0) {
                        return "No se pudo obtener información de búsqueda web.";
                    }

                    let webSearchResults = "";
                    let citations = [];

                    for (const contentBlock of data.content) {
                        if (contentBlock.type === "text") {
                            webSearchResults += contentBlock.text;

                            if (contentBlock.citations && contentBlock.citations.length > 0) {
                                citations = citations.concat(contentBlock.citations);
                            }
                        }
                    }

                    if (citations.length > 0) {
                        webSearchResults += "\n\nFuentes consultadas:";
                        citations.forEach((citation, index) => {
                            if (citation.url && citation.title) {
                                webSearchResults += `\n${index + 1}. ${citation.title} - ${citation.url}`;
                            }
                        });
                    }

                    //console.log("Resultados de búsqueda web:", webSearchResults);
                    //console.log("Uso de tokens:", data.usage);

                    return webSearchResults;
                })
                .catch((error) => {
                    console.error('Error haciendo la petición de búsqueda web:', error);
                    return `Error al realizar búsqueda web: ${error.message}`;
                });

            return response;

        } catch (error) {
            console.error('Error en búsqueda web:', error);
            throw new Error(`Error al realizar búsqueda web: ${error.message}`);
        } finally {
            setWebSearchLoading(false);
        }
    };

    const performImageAnalysis = async (file, userPrompt = '') => {
        /*   console.log('Iniciando análisis de imagen...', {
              fileName: file.name,
              fileSize: file.size,
              fileType: file.type,
              userPrompt: userPrompt
          }); */

        try {
            const CLAUDE_API_KEY = process.env.REACT_APP_CLAUDE_API_KEY || "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";

            if (!CLAUDE_API_KEY || CLAUDE_API_KEY === 'tu-api-key-aqui') {
                throw new Error('API key de Claude no configurada');
            }

            const base64 = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const result = reader.result;
                        if (typeof result === 'string') {
                            const base64Data = result.split(',')[1];
                            if (!base64Data) {
                                reject(new Error('Error al extraer datos base64'));
                                return;
                            }
                            resolve(base64Data);
                        } else {
                            reject(new Error('Formato de archivo no válido'));
                        }
                    } catch (error) {
                        reject(error);
                    }
                };
                reader.onerror = () => reject(new Error('Error al leer el archivo'));
                reader.readAsDataURL(file);
            });

            let analysisPrompt = `Analiza esta imagen en el contexto de análisis de datos de negocio. `;

            if (userPrompt && userPrompt.trim()) {
                analysisPrompt += `El usuario quiere: "${userPrompt}". `;
                analysisPrompt += `Describe la imagen de manera que sea útil para responder a esta consulta de negocio. `;
                analysisPrompt += `Si la imagen contiene datos (gráficos, tablas, números), extrae esa información. `;
                analysisPrompt += `Si la imagen muestra procesos de negocio, identifica patrones relevantes. `;
                analysisPrompt += `Proporciona una interpretación que ayude a responder la consulta del usuario.`;
            } else {
                analysisPrompt += `Describe la imagen enfocándote en cualquier información de negocio, datos, `;
                analysisPrompt += `gráficos, tablas, procesos o elementos que puedan ser relevantes para análisis empresarial.`;
            }

            //console.log('Enviando solicitud a Claude API...');

            const response = await fetch('https://api.anthropic.com/v1/messages', {
                method: 'POST',
                headers: {
                    'x-api-key': CLAUDE_API_KEY,
                    'anthropic-version': '2023-06-01',
                    'content-type': 'application/json',
                    'anthropic-dangerous-direct-browser-access': 'true'
                },
                body: JSON.stringify({
                    model: 'claude-3-5-sonnet-20241022',
                    max_tokens: 1500,
                    messages: [
                        {
                            role: 'user',
                            content: [
                                {
                                    type: 'image',
                                    source: {
                                        type: 'base64',
                                        media_type: file.type,
                                        data: base64
                                    }
                                },
                                {
                                    type: 'text',
                                    text: analysisPrompt
                                }
                            ]
                        }
                    ]
                })
            });

            if (!response.ok) {
                let errorMessage = `Error HTTP: ${response.status}`;

                switch (response.status) {
                    case 401:
                        errorMessage = 'API key inválida o no autorizada';
                        break;
                    case 400:
                        errorMessage = 'Solicitud inválida. Verifica el formato de la imagen';
                        break;
                    case 429:
                        errorMessage = 'Límite de solicitudes excedido. Intenta de nuevo en unos minutos';
                        break;
                    case 500:
                        errorMessage = 'Error del servidor de Claude. Intenta de nuevo más tarde';
                        break;
                }

                throw new Error(errorMessage);
            }

            const data = await response.json();
            const analysisText = data.content?.[0]?.text;

            if (!analysisText) {
                throw new Error('Respuesta de Claude sin contenido de texto');
            }

            return analysisText;

        } catch (error) {
            console.error('Error completo en análisis de imagen:', error);
            throw error;
        }
    };

    const getSuggestedQuestions = async (previousQuestion, botResponse) => {
        setLoadingSuggestions(true);
        const apiKey = "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";

        const prompt = buildSuggestedQuestionsPrompt(previousQuestion, botResponse);

        try {
            const response = await fetch("https://api.anthropic.com/v1/messages", {
                method: "POST",
                headers: {
                    "x-api-key": apiKey,
                    "anthropic-version": "2023-06-01",
                    "content-type": "application/json",
                    "anthropic-dangerous-direct-browser-access": "true"
                },
                body: JSON.stringify({
                    model: "claude-sonnet-4-20250514",
                    max_tokens: 1000,
                    messages: [{ role: "user", content: prompt }]
                })
            });

            if (!response.ok) {
                console.error('Error en la API de Claude:', response.statusText);
                setLoadingSuggestions(false);
                return;
            }

            const data = await response.json();
            const responseText = data.content[0].text;

            try {
                const newQuestions = JSON.parse(responseText);
                if (Array.isArray(newQuestions) && newQuestions.length >= 3) {
                    setSuggestedQuestions(newQuestions.slice(0, 3));
                } else {
                    console.warn('Formato inesperado de preguntas:', responseText);
                    const extractedQuestions = responseText.match(/"([^"]+)"/g);
                    if (extractedQuestions && extractedQuestions.length >= 3) {
                        const cleanQuestions = extractedQuestions.slice(0, 3).map(q => q.replace(/"/g, ''));
                        setSuggestedQuestions(cleanQuestions);
                    }
                }
            } catch (parseError) {
                console.error('Error al analizar respuesta JSON:', parseError);

                const extractedQuestions = responseText.match(/"([^"]+)"/g);
                if (extractedQuestions && extractedQuestions.length >= 3) {
                    const cleanQuestions = extractedQuestions.slice(0, 3).map(q => q.replace(/"/g, ''));
                    setSuggestedQuestions(cleanQuestions);
                }
            }
        } catch (error) {
            console.error('Error al obtener preguntas sugeridas:', error);
        } finally {
            setLoadingSuggestions(false);
        }
    };

    const consultClaude = async (originalQuery, errorMessage) => {
        const apiKey = "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";

        const content = buildConsultClaudePrompt(originalQuery, errorMessage);
        try {
            const response = await fetch("https://api.anthropic.com/v1/messages", {
                method: "POST",
                headers: {
                    "x-api-key": apiKey,
                    "anthropic-version": "2023-06-01",
                    "content-type": "application/json",
                    "anthropic-dangerous-direct-browser-access": "true"
                },
                body: JSON.stringify({
                    model: "claude-sonnet-4-20250514",
                    max_tokens: 1000,
                    messages: [
                        {
                            role: "user",
                            content: content
                        }
                    ]
                })
            });

            if (!response.ok) {
                console.error('Error en la API de Claude:', response.statusText);
                return null;
            }

            const data = await response.json();
            return data.content[0].text;
        } catch (error) {
            console.error('Error haciendo la petición a Claude:', error);
            return null;
        }
    };

    /* ---------------  ---------------  --------------- Funciones para el modulo de visualización ---------------  ---------------  --------------- */

    const getQuery = async (id_message) => {
        try {
            const authenticatedRequest = await createAuthenticatedRequest(config);
            const url = `${baseURL}${endpoint_get_sql}?id_message=${encodeURIComponent(id_message)}`;
            const response = await authenticatedRequest(url, 'GET', null);
            return response.messages

        } catch (error) {
            console.error('Error creating new conversation:', error);
            return "None"
        }
    };

    function safeJSONStringify(obj) {
        try {
            return JSON.stringify(obj);
        } catch (error) {
            console.warn("Error en serialización JSON:", error);

            const seen = new WeakSet();
            return JSON.stringify(obj, (key, value) => {
                if (typeof value === 'object' && value !== null) {
                    if (seen.has(value)) {
                        return "[Referencia Circular]";
                    }
                    seen.add(value);
                }
                if (typeof value === 'function') {
                    return "[Función]";
                }
                if (value instanceof Error) {
                    return {
                        errorType: value.name,
                        errorMessage: value.message
                    };
                }
                return value;
            }, 2);
        }
    }

    const executeSQL = async (sqlStatement) => {
        try {
            const url = `${baseURLBD}${endpoint_executeSQL}?sqlStatement=${encodeURIComponent(sqlStatement)}`;

            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 30000);

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                signal: controller.signal
            });

            clearTimeout(timeoutId);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error executing SQL query:', error);

            let errorMessage = "Error al ejecutar la consulta SQL";

            if (error.name === 'AbortError') {
                errorMessage = "La consulta ha excedido el tiempo máximo de ejecución";
            } else if (error.message) {
                errorMessage = error.message;
            }

            return {
                data: [],
                columns: {},
                query: sqlStatement,
                error: errorMessage
            };
        }
    };

    const handleDownloadTableAsExcel = (tableElement) => {
        try {
            const rows = tableElement.querySelectorAll('tr');
            const data = [];

            rows.forEach((row, index) => {
                const cells = row.querySelectorAll('th, td');
                const rowData = {};

                cells.forEach((cell, cellIndex) => {
                    const columnName = index === 0 ?
                        cell.textContent.trim() :
                        `Column_${cellIndex + 1}`;

                    if (index === 0) {
                        rowData[columnName] = columnName;
                    } else {
                        const headers = Array.from(tableElement.querySelectorAll('tr:first-child th, tr:first-child td'));
                        const headerText = headers[cellIndex]?.textContent.trim() || `Column_${cellIndex + 1}`;
                        rowData[headerText] = cell.textContent.trim();
                    }
                });

                if (index > 0) {
                    data.push(rowData);
                }
            });

            const timestamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\..+/, '');

            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Tabla');
            XLSX.writeFile(workbook, `tabla_${timestamp}.xlsx`);

        } catch (error) {
            console.error('Error al descargar tabla:', error);
            alert('Error al generar el archivo Excel');
        }
    };

    const handleGenerateExcel = () => {
        if (!queryData || !queryData.data) {
            console.error('No hay datos disponibles para generar el Excel.');
            return;
        }

        const timestamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\..+/, '');

        const worksheet = XLSX.utils.json_to_sheet(queryData.data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Datos');
        XLSX.writeFile(workbook, `resultado_${timestamp}.xlsx`);
    };

    /* --------------- ---------------  ---------------  Petición de bedrock --------------- ---------------  ---------------  */

    const createAuthenticatedRequest = async (config) => {
        const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
        const my_login = 'cognito-idp.' + config.aws_project_region + '.amazonaws.com/' + config.aws_user_pools_id;

        const credentials = fromCognitoIdentityPool({
            clientConfig: { region: config.aws_project_region },
            identityPoolId: config.aws_cognito_identity_pool_id,
            logins: { [my_login]: authToken }
        });

        const signer = new SignatureV4({
            credentials: credentials,
            region: config.aws_project_region,
            service: 'execute-api',
            sha256: Sha256
        });

        return async (endpoint, method = 'GET', body = null) => {
            const url = new URL(endpoint);

            const request = new HttpRequest({
                hostname: url.hostname,
                path: url.pathname + url.search,
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                    host: url.hostname
                },
                body: body ? JSON.stringify(body) : undefined
            });

            const signedRequest = await signer.sign(request);

            const fetchOptions = {
                method: signedRequest.method,
                headers: signedRequest.headers,
                body: signedRequest.body
            };

            const response = await fetch(url.toString(), fetchOptions);
            return response.json();
        };
    };

    // 🔥 MEJORADO: SQL Validator con limpieza más agresiva
    const enhancedCleanSQL = (sql) => {
        if (!sql) return '';

        let cleaned = sql;

        //console.log('🔍 SQL Original recibido:', sql.substring(0, 200));

        // Remover bloques de markdown
        cleaned = cleaned.replace(/```sql\s*/gi, '');
        cleaned = cleaned.replace(/```\s*/g, '');

        // 🔥 Remover texto antes del primer SELECT/WITH
        const sqlStart = cleaned.search(/\b(SELECT|WITH|INSERT|UPDATE|DELETE|CREATE)\b/i);
        if (sqlStart > 0) {
            cleaned = cleaned.substring(sqlStart);
        }

        // 🔥 Remover texto después del último ;
        const lastSemicolon = cleaned.lastIndexOf(';');
        if (lastSemicolon !== -1) {
            cleaned = cleaned.substring(0, lastSemicolon + 1);
        }

        // Limpiar espacios
        cleaned = cleaned.trim();
        cleaned = cleaned.replace(/\n{3,}/g, '\n\n');

        // 🔥 Remover líneas que no son SQL
        const lines = cleaned.split('\n');
        const sqlLines = lines.filter(line => {
            const trimmed = line.trim();
            if (!trimmed) return true;
            if (trimmed.startsWith('--')) return true;
            if (trimmed.startsWith('/*')) return true;
            // Rechazar líneas que parecen explicaciones
            if (/^(here|this|the query|explanation|note|i've|let me)/i.test(trimmed)) return false;
            return true;
        });
        cleaned = sqlLines.join('\n').trim();

        //console.log('✅ SQL Limpio resultante:', cleaned.substring(0, 200));

        return cleaned;
    };

    // 🔥 OPTIMIZADO: Invocar Agente SQL con reintentos y timeout
    const invokeBedrockAgentForSQL = async (mensajes_anteriores, userContent, botContent, sessionId, maxRetries = 2) => {
        const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
        const my_login = 'cognito-idp.' + config.aws_project_region + '.amazonaws.com/' + config.aws_user_pools_id;

        // 🔥 NUEVO: Revisar cache primero
        const cacheKey = `${userContent}_${botContent}`;
        if (sqlCacheRef.current.has(cacheKey)) {
            //console.log('💾 SQL encontrado en cache');
            return sqlCacheRef.current.get(cacheKey);
        }

        const bedrock = new BedrockAgentRuntimeClient({
            region: config.aws_project_region,
            credentials: fromCognitoIdentityPool({
                clientConfig: { region: config.aws_project_region },
                identityPoolId: config.aws_cognito_identity_pool_id,
                logins: { [my_login]: authToken }
            })
        });

        const mensajes_form = mensajes_anteriores.map(({ question, query }) => ({ question, query }));
        const sqlPrompt = buildSQLPrompt(userContent, safeJSONStringify(mensajes_form));

        // 🔥 Sistema de reintentos
        for (let attempt = 1; attempt <= maxRetries; attempt++) {
            try {
                //console.log(`📊 Intento ${attempt}/${maxRetries} - Solicitando SQL...`);

                const input = {
                    agentId: SQL_AGENT_ID,
                    agentAliasId: SQL_AGENT_ALIAS_ID,
                    sessionId: sessionId || id_conversation,
                    inputText: sqlPrompt,
                    enableTrace: false, // 🔥 Deshabilitado para velocidad
                    streamingConfigurations: {
                        streamFinalResponse: true,
                        applyGuardrailInterval: 50
                    }
                };

                const command = new InvokeAgentCommand(input);
                let sqlQuery = "";

                // 🔥 TIMEOUT de 15 segundos
                const timeoutPromise = new Promise((_, reject) =>
                    setTimeout(() => reject(new Error('SQL generation timeout')), 15000)
                );

                const responsePromise = (async () => {
                    const response = await bedrock.send(command);

                    if (response.completion === undefined) {
                        throw new Error("Completion is undefined");
                    }

                    for await (let chunkEvent of response.completion) {
                        if (chunkEvent.chunk) {
                            const chunk = chunkEvent.chunk;
                            const decodedResponse = new TextDecoder("utf-8").decode(chunk.bytes);
                            sqlQuery += decodedResponse;
                        }
                    }

                    return sqlQuery;
                })();

                sqlQuery = await Promise.race([responsePromise, timeoutPromise]);

                //console.log("📦 SQL Raw recibido:", sqlQuery.substring(0, 100));

                if (!sqlQuery || sqlQuery.trim().length === 0) {
                    throw new Error("El agente devolvió una respuesta vacía");
                }

                // Limpiar el SQL
                const cleanedSQL = enhancedCleanSQL(sqlQuery);

                //console.log("🧹 SQL después de limpieza:", cleanedSQL.substring(0, 100));

                // 🔥 Validar que realmente es SQL
                if (!cleanedSQL.match(/\b(SELECT|WITH|INSERT|UPDATE|DELETE)\b/i)) {
                    throw new Error("La respuesta no contiene SQL válido");
                }

                // 🔥 Validar sintaxis
                const validator = new SQLValidator();
                const validation = validator.validate(cleanedSQL);
                if (!validation.valid) {
                    console.warn(`⚠️ SQL con advertencias (intento ${attempt}):`, validation.errors);
                    if (attempt === maxRetries) {
                        //console.log("⚠️ Último intento - usando SQL a pesar de advertencias");

                        // 🔥 Guardar en cache
                        sqlCacheRef.current.set(cacheKey, cleanedSQL);
                        return cleanedSQL;
                    }
                    throw new Error(`SQL inválido: ${validation.errors.join(', ')}`);
                }

                //console.log(`✅ SQL válido generado en intento ${attempt}`);

                // 🔥 Guardar en cache
                sqlCacheRef.current.set(cacheKey, cleanedSQL);
                return cleanedSQL;

            } catch (error) {
                console.error(`❌ Error en intento ${attempt}/${maxRetries}:`, error.message);

                if (attempt === maxRetries) {
                    throw new Error(`Fallo después de ${maxRetries} intentos: ${error.message}`);
                }

                // Backoff exponencial
                await new Promise(resolve => setTimeout(resolve, 1000 * attempt));
                //console.log(`🔄 Reintentando (${attempt + 1}/${maxRetries})...`);
            }
        }
    };

    // 🔥 FUNCIÓN OPTIMIZADA: Actualizar UI con RAF
    const scheduleStreamUpdate = (messageId) => {
        if (!animationFrameRef.current && isStreamingRef.current) {
            animationFrameRef.current = requestAnimationFrame(() => {
                setMessages(prevMessages =>
                    prevMessages.map(msg => {
                        if (msg.id !== messageId) return msg;

                        if (!streamingBufferRef.current || streamingBufferRef.current.trim() === '') {
                            return {
                                ...msg,
                                content: (
                                    <span className="thinking-dots">
                                        {currentLoadingPhraseRef.current || '🤖 Procesando con inteligencia artificial...'}
                                    </span>
                                )
                            };
                        }

                        return {
                            ...msg,
                            content: (
                                <div>
                                    <ReactMarkdown
                                        remarkPlugins={[remarkGfm]}
                                        components={{
                                            code({ node, inline, className, children, ...props }) {
                                                const match = /language-(\w+)/.exec(className || '');
                                                return !inline && match ? (
                                                    <SyntaxHighlighter
                                                        style={tomorrow}
                                                        language={match[1]}
                                                        PreTag="div"
                                                        {...props}
                                                    >
                                                        {String(children).replace(/\n$/, '')}
                                                    </SyntaxHighlighter>
                                                ) : (
                                                    <code className={className} {...props}>
                                                        {children}
                                                    </code>
                                                );
                                            },
                                            table({ children }) {
                                                return <MarkdownTableWithDownload>{children}</MarkdownTableWithDownload>;
                                            },
                                            thead({ children }) {
                                                return <thead className="markdown-thead">{children}</thead>;
                                            },
                                            tbody({ children }) {
                                                return <tbody className="markdown-tbody">{children}</tbody>;
                                            },
                                            tr({ children }) {
                                                return <tr className="markdown-tr">{children}</tr>;
                                            },
                                            th({ children, style }) {
                                                return (
                                                    <th className="markdown-th" style={style}>
                                                        {children}
                                                    </th>
                                                );
                                            },
                                            td({ children, style }) {
                                                return (
                                                    <td className="markdown-td" style={style}>
                                                        {children}
                                                    </td>
                                                );
                                            },
                                            h1: ({ children }) => <h1 style={{ color: '#333', marginBottom: '10px' }}>{children}</h1>,
                                            h2: ({ children }) => <h2 style={{ color: '#555', marginBottom: '8px' }}>{children}</h2>,
                                            h3: ({ children }) => <h3 style={{ color: '#777', marginBottom: '6px' }}>{children}</h3>,
                                            p: ({ children }) => <p style={{ marginBottom: '10px', lineHeight: '1.6' }}>{children}</p>,
                                            ul: ({ children }) => <ul style={{ marginLeft: '20px', marginBottom: '10px' }}>{children}</ul>,
                                            ol: ({ children }) => <ol style={{ marginLeft: '20px', marginBottom: '10px' }}>{children}</ol>,
                                            li: ({ children }) => <li style={{ marginBottom: '5px' }}>{children}</li>,
                                            blockquote: ({ children }) => (
                                                <blockquote style={{
                                                    borderLeft: '4px solid #ddd',
                                                    paddingLeft: '15px',
                                                    margin: '10px 0',
                                                    fontStyle: 'italic',
                                                    color: '#666'
                                                }}>
                                                    {children}
                                                </blockquote>
                                            )
                                        }}
                                    >
                                        {streamingBufferRef.current}
                                    </ReactMarkdown>
                                    <span className="cursor-parpadeante">▊</span>
                                </div>
                            )
                        };
                    })
                );

                animationFrameRef.current = null;

                if (isStreamingRef.current) {
                    scheduleStreamUpdate(messageId);
                }
            });
        }
    };

    // 🔥 NUEVO BACKEND CON CLAUDE API Y STREAMING
    const invokeBackendAgent = async (prompt, sessionId, id_message_bot, messageId, selectedAgentType, fileData = null) => {
        let completion = "";

        streamingBufferRef.current = '';
        isStreamingRef.current = true;

        try {
            console.log(`🤖 Llamando al backend Flask con Claude API...`);
            console.log(`🎯 Tipo de agente seleccionado: ${selectedAgentType}`);
            if (fileData) {
                console.log(`📁 Con archivo adjunto: ${fileData.filename}`);
            }

            scheduleStreamUpdate(messageId);

            // Obtener historial de mensajes para el contexto
            const conversationHistory = messages
                .filter(msg => !msg.temp && msg.author !== 'Bot')
                .slice(-10)  // Últimos 10 mensajes
                .map(msg => ({
                    role: msg.author === 'Client' ? 'user' : 'assistant',
                    content: msg.text || msg.message || ''
                }));

            await streamQuery(
                prompt,
                user.username,
                conversationHistory,
                {
                    onThinking: (eventType, content) => {
                        if (eventType === 'start') {
                            console.log('💭 Thinking iniciado');
                            setShowThinking(true);
                            setThinkingMessage('');
                        } else if (eventType === 'chunk') {
                            setThinkingMessage(content);
                        } else if (eventType === 'stop') {
                            console.log('💭 Thinking completado');
                            setShowThinking(false);
                        }
                    },
                    onChunk: (chunk, accumulated) => {
                        completion = accumulated;
                        streamingBufferRef.current += chunk;
                    },
                    onToolUse: (toolName) => {
                        console.log('🔧 Tool usado:', toolName);
                    },
                    onComplete: (finalText) => {
                        completion = finalText;
                        isStreamingRef.current = false;
                        setShowThinking(false);  // 🆕 Asegurar que thinking se oculte
                        setThinkingMessage('');

                        if (animationFrameRef.current) {
                            cancelAnimationFrame(animationFrameRef.current);
                            animationFrameRef.current = null;
                        }
                    },
                    onError: (error) => {
                        console.error('❌ Error en streaming:', error);
                        isStreamingRef.current = false;
                        setShowThinking(false);  // 🆕 Ocultar thinking en error
                        setThinkingMessage('');

                        if (animationFrameRef.current) {
                            cancelAnimationFrame(animationFrameRef.current);
                            animationFrameRef.current = null;
                        }
                    }
                },
                selectedAgentType,  // 🎯 Tipo de agente
                fileData  // 📁 Archivo adjunto
            );

            return {
                completion
            };

        } catch (error) {
            isStreamingRef.current = false;
            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current);
                animationFrameRef.current = null;
            }
            throw error;
        }
    };

    const handleInvokeAgent = async (message, sessionId, id_message_bot, messageId, fileData = null) => {
        try {
            const result = await invokeBackendAgent(message, sessionId, id_message_bot, messageId, agentType, fileData);
            setResponse(result.completion);

            // ⚠️ Visualización ahora se hace manual con el botón "Visualizar Datos"
            // que usa el nuevo backend de IQVIA Agent en Railway

            getSuggestedQuestions(message, result.completion);

            return result.completion;
        } catch (error) {
            console.error("Error invoking agent:", error);
            throw error;
        }
    };

    const MarkdownTableWithDownload = ({ children }) => {
        const tableRef = useRef(null);

        const handleDownloadTable = () => {
            //console.log("Descargando tabla...");
            handleDownloadTableAsExcel(tableRef.current);
        };

        return (
            <div className="markdown-table-wrapper">
                <div className="table-header">
                    <button
                        className="download-table-btn"
                        onClick={handleDownloadTable}
                        title="Descargar tabla como Excel"
                    >
                        <FaFileExcel size={12} />
                        Descargar
                    </button>
                </div>
                <div className="markdown-table-container">
                    <table className="markdown-table" ref={tableRef}>
                        {children}
                    </table>
                </div>
            </div>
        );
    };

    // 🎨 handleViz integrado con backend IQVIA Agent
    const handleViz = async (id_message) => {
        // Cache check
        if (vizData[id_message]) {
            setModalIsOpen(true);
            setQueryData(vizData[id_message]);
            return;
        }

        if (vizLoading[id_message]) {
            setModalIsOpen(true);
            setLoading(true);
            return;
        }

        const messageIndex = messages.findIndex(msg => msg.id_message === id_message);
        const userMessageIndex = messageIndex > 0 ? messageIndex - 1 : -1;
        const userContent = userMessageIndex >= 0 && messages[userMessageIndex].author === 'Client'
            ? messages[userMessageIndex].content
            : "";
        const botContent = messages[messageIndex].content;

        // Validar que tengamos contenido
        if (!userContent || !botContent) {
            console.error("❌ No se encontró contenido de usuario o bot");
            setQueryData({
                data: [],
                columns: {},
                query: "",
                column_types: {},
                hasError: true,
                error: "No se pudo encontrar el contexto de la conversación para generar la visualización."
            });
            setModalIsOpen(true);
            return;
        }

        setModalIsOpen(true);
        setLoading(true);
        setVizLoading(prev => ({ ...prev, [id_message]: true }));

        try {
            console.log("[HANDLE-VIZ] 📊 Generando visualización con nuevo backend IQVIA Agent");
            console.log(`[HANDLE-VIZ] Tipo de agente: ${agentType}`);

            // 🎨 Llamar al nuevo backend de IQVIA Agent
            const result = await generateVisualizationSQL(
                userContent,
                botContent,
                agentType  // 'subnacional' o 'nacional'
            );

            if (!result.success) {
                throw new Error(result.error || "No se pudo generar SQL de visualización");
            }

            console.log("[HANDLE-VIZ] ✅ SQL generado exitosamente:", result.sql?.substring(0, 100));

            // Formatear datos para el componente de visualización
            const vizDataFormatted = {
                data: result.data || [],
                columns: result.columns || [],
                query: result.sql || "",
                column_types: result.column_types || {},
                hasError: false
            };

            // Guardar en cache
            setVizData(prev => ({
                ...prev,
                [id_message]: vizDataFormatted
            }));

            setQueryData(vizDataFormatted);

            console.log("[HANDLE-VIZ] ✅ Visualización lista:", {
                rows: result.data?.length || 0,
                columns: result.columns?.length || 0
            });

        } catch (error) {
            console.error("❌ Error en handleViz:", error);

            let userFriendlyError = "No se puede generar la gráfica. ";

            if (error.message.includes("operator does not exist")) {
                userFriendlyError += "Hay un problema de compatibilidad entre tipos de datos.";
            } else if (error.message.includes("column") || error.message.includes("tabla")) {
                userFriendlyError += "Se intentó acceder a columnas o tablas que no existen.";
            } else if (error.message.includes("backend") || error.message.includes("fetch")) {
                userFriendlyError += "No se pudo conectar con el servidor. Verifica que el backend esté corriendo.";
            } else {
                userFriendlyError += error.message || "Ha ocurrido un error al procesar la consulta.";
            }

            userFriendlyError += " Intenta reformular tu pregunta.";

            setQueryData({
                data: [],
                columns: [],
                query: "",
                column_types: {},
                hasError: true,
                error: userFriendlyError
            });
        } finally {
            setLoading(false);
            setVizLoading(prev => ({ ...prev, [id_message]: false }));
        }
    };

    /* --------------- Función enviar formulario --------------- */

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!message.trim() && !uploadedFile) return;

        // 📁 Capturar archivo actual antes de limpiar
        const currentFile = uploadedFile;

        let finalQuery = message;
        let webSearchContext = "";
        let imageAnalysisContext = "";
        let firstAgentMessageId = null;
        let bedrockMessageId = null;

        let hasImageProcessing = false;
        let hasWebSearchProcessing = false;

        if (imageFile) {
            //console.log('Procesando imagen para análisis...');
            hasImageProcessing = true;

            try {
                addMessage('Client', message);
                setMessage('');
                adjustTextareaHeight(messageInputRef.current);

                // 📁 Limpiar archivo si existe
                if (currentFile) {
                    setUploadedFile(null);
                    setFileClearTrigger(Date.now());
                }

                firstAgentMessageId = Date.now();

                const imageAnalysisMessage = {
                    author: 'Bot',
                    content: (
                        <div className="image-analysis-progress">
                            <span className="thinking-dots">
                                🔍 Analizando imagen...
                            </span>
                            <div style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>
                                Extrayendo información relevante de la imagen
                            </div>
                        </div>
                    ),
                    type: 'text',
                    data: null,
                    id: firstAgentMessageId,
                    temp: true,
                    isImageAnalysisMessage: true,
                    isPreviewMessage: true
                };
                setMessages(prevMessages => [...prevMessages, imageAnalysisMessage]);

                setTimeout(() => {
                    scrollToBottom();
                }, 200);

                const imageToAnalyze = imageFile;
                const userPrompt = message.trim();

                clearImage();

                imageAnalysisContext = await performImageAnalysis(imageToAnalyze, userPrompt);

                if (imageAnalysisContext && !imageAnalysisContext.includes("Error")) {
                    finalQuery = `INFORMACIÓN EXTRAÍDA DE LA IMAGEN:
                ${imageAnalysisContext}

                CONSULTA ORIGINAL DEL USUARIO:
                ${userPrompt}

                Por favor, utiliza la información extraída de la imagen junto con nuestros datos internos para proporcionar una respuesta completa y relevante a la consulta del usuario.`;
                } else {
                    finalQuery = userPrompt;
                    imageAnalysisContext = "";
                }

                setMessages(prevMessages =>
                    prevMessages.map(msg =>
                        msg.id === firstAgentMessageId ? {
                            ...msg,
                            content: (
                                <div>
                                    {imageAnalysisContext && !imageAnalysisContext.includes("Error") ? (
                                        <div className="image-info-card">
                                            <strong>🔍 Imagen analizada correctamente</strong>
                                            <div className="image-info-content">
                                                {imageAnalysisContext}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="image-analysis-error">
                                            <strong>⚠️ Error al analizar imagen</strong>
                                            <div style={{ marginTop: "5px", fontSize: "0.9em" }}>
                                                Continuando con análisis de datos internos...
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ),
                            temp: false,
                            isImageAnalysisMessage: true,
                            isPreviewMessage: true
                        } : msg
                    )
                );

                setTimeout(() => {
                    scrollToBottom();
                }, 200);

            } catch (imageError) {
                console.error('Error en análisis de imagen:', imageError);

                setMessages(prevMessages =>
                    prevMessages.map(msg =>
                        msg.id === firstAgentMessageId ? {
                            ...msg,
                            content: (
                                <div className="image-analysis-error">
                                    <strong>⚠️ No se pudo analizar la imagen</strong>
                                    <div style={{ marginTop: "5px", fontSize: "0.9em" }}>
                                        Continuando con análisis de datos internos...
                                    </div>
                                </div>
                            ),
                            temp: false,
                            isImageAnalysisMessage: true,
                            isPreviewMessage: true
                        } : msg
                    )
                );

                finalQuery = message;
            }

        } else if (webSearchEnabled) {
            hasWebSearchProcessing = true;

            try {
                addMessage('Client', message);
                setMessage('');
                adjustTextareaHeight(messageInputRef.current);

                firstAgentMessageId = Date.now();

                const webSearchMessage = {
                    author: 'Bot',
                    content: (
                        <span className="thinking-dots">
                            <FaGlobe style={{ marginRight: "5px" }} />
                            Buscando información actualizada en la web...
                        </span>
                    ),
                    type: 'text',
                    data: null,
                    id: firstAgentMessageId,
                    temp: true,
                    isWebSearchMessage: true,
                    isPreviewMessage: true
                };
                setMessages(prevMessages => [...prevMessages, webSearchMessage]);

                setTimeout(() => {
                    scrollToBottom();
                }, 200);

                webSearchContext = await performWebSearch(message);

                if (webSearchContext.includes("No se requiere búsqueda web") ||
                    webSearchContext.includes("No se pudo encontrar información")) {

                    finalQuery = message;
                    webSearchContext = "";

                } else {
                    finalQuery = `INFORMACIÓN EXTERNA COMPLEMENTARIA:
                ${webSearchContext}

                CONSULTA ORIGINAL DEL USUARIO:
                ${message}

                Por favor, utiliza la información externa proporcionada junto con nuestros datos internos para dar una respuesta más completa y actualizada.`;
                }

                setMessages(prevMessages =>
                    prevMessages.map(msg =>
                        msg.id === firstAgentMessageId ? {
                            ...msg,
                            content: (
                                <div>
                                    {webSearchContext && !webSearchContext.includes("No se requiere búsqueda web") && !webSearchContext.includes("No se pudo encontrar información") ? (
                                        <div className="web-info-card">
                                            <strong><FaGlobe style={{ marginRight: "5px" }} />Información externa encontrada</strong>
                                            <div className="web-info-content">
                                                {webSearchContext}
                                            </div>
                                        </div>
                                    ) : webSearchContext.includes("No se requiere búsqueda web") ? (
                                        <div className="web-search-success">
                                            <strong><FaGlobe style={{ marginRight: "5px" }} />Búsqueda web no necesaria</strong>
                                            <div style={{ marginTop: "5px", fontSize: "0.9em" }}>
                                                La consulta puede responderse completamente con datos internos
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="web-search-loading">
                                            <strong><FaGlobe style={{ marginRight: "5px" }} />Información externa no encontrada</strong>
                                            <div style={{ marginTop: "5px", fontSize: "0.9em" }}>
                                                Continuando con análisis de datos internos...
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ),
                            temp: false,
                            isWebSearchMessage: true,
                            isPreviewMessage: true
                        } : msg
                    )
                );

                setTimeout(() => {
                    scrollToBottom();
                }, 200);

            } catch (webError) {
                console.error('Error en búsqueda web:', webError);

                setMessages(prevMessages =>
                    prevMessages.map(msg =>
                        msg.id === firstAgentMessageId ? {
                            ...msg,
                            content: (
                                <div className="web-search-error">
                                    <strong>⚠️ Búsqueda web no disponible</strong>
                                    <div style={{ marginTop: "5px", fontSize: "0.9em" }}>
                                        Continuando con análisis de datos internos...
                                    </div>
                                </div>
                            ),
                            temp: false,
                            isWebSearchMessage: true,
                            isPreviewMessage: true
                        } : msg
                    )
                );

                finalQuery = message;
            }

        } else {
            addMessage('Client', message || '📎 Archivo adjunto');
            setMessage('');
            adjustTextareaHeight(messageInputRef.current);
        }

        // 📁 Limpiar archivo después de enviar
        if (currentFile) {
            setUploadedFile(null);
            setFileClearTrigger(Date.now());
            console.log('[ChatBot] 🗑️ Archivo enviado y limpiado');
        }

        bedrockMessageId = Date.now() + 1;

        const initialPhrase = loadingPhrases[Math.floor(Math.random() * loadingPhrases.length)];
        currentLoadingPhraseRef.current = initialPhrase;

        const bedrockLoadingMessage = {
            author: 'Bot',
            content: (
                <span className="thinking-dots">
                    {initialPhrase}
                </span>
            ),
            type: 'text',
            data: null,
            id: bedrockMessageId,
            temp: true,
            isBedrockMessage: true,
            isPreviewMessage: false
        };

        setMessages(prevMessages => [...prevMessages, bedrockLoadingMessage]);

        setTimeout(() => {
            scrollToBottom();
        }, 200);

        try {
            let id_message_client = uuidv4();
            let response_message_client = await addMessageBD(id_conversation, id_user, message, "Client", id_message_client);

            let id_message_bot = uuidv4();

            let responseBedrock = await handleInvokeAgent(finalQuery, id_conversation, id_message_bot, bedrockMessageId, currentFile);

            if (responseBedrock === undefined || responseBedrock === "Sorry, I am unable to assist you with this request.") {
                const claudeSuggestions = await consultClaude(
                    message,
                    "El servidor no pudo procesar esta consulta."
                );

                if (claudeSuggestions) {
                    responseBedrock = `La consulta no puede procesarse. Aquí hay alternativas:\n\n${claudeSuggestions}`;
                } else {
                    responseBedrock = "Lo siento, no puedo procesar esta consulta. Intenta ser más específico.";
                }
            }

            let response_message_bot = await addMessageBD(id_conversation, id_user, responseBedrock, "Bot", id_message_bot);

            setMessages(prevMessages => {
                const filteredMessages = prevMessages.filter(msg =>
                    !(msg.isPreviewMessage && (msg.id === firstAgentMessageId))
                );

                return filteredMessages.map(msg =>
                    msg.id === bedrockMessageId ? {
                        ...msg,
                        id_message: id_message_bot,
                        text: responseBedrock,
                        content: (
                            <div>
                                {hasImageProcessing && imageAnalysisContext &&
                                    !imageAnalysisContext.includes("Error") && (
                                        <div className="image-context-container">
                                            <details>
                                                <summary>
                                                    🔍 Información extraída de la imagen (click para ver)
                                                </summary>
                                                <div className="image-context-content">
                                                    <ReactMarkdown>{imageAnalysisContext}</ReactMarkdown>
                                                </div>
                                            </details>
                                        </div>
                                    )}

                                {hasWebSearchProcessing && webSearchContext &&
                                    !webSearchContext.includes("No se requiere búsqueda web") &&
                                    !webSearchContext.includes("No se pudo encontrar información") && (
                                        <div className="web-context-container">
                                            <details>
                                                <summary>
                                                    <FaGlobe style={{ marginRight: "5px" }} />
                                                    Información externa utilizada (click para ver)
                                                </summary>
                                                <div className="web-context-content">
                                                    <ReactMarkdown>{webSearchContext}</ReactMarkdown>
                                                </div>
                                            </details>
                                        </div>
                                    )}

                                <ReactMarkdown
                                    remarkPlugins={[remarkGfm]}
                                    components={{
                                        code({ node, inline, className, children, ...props }) {
                                            const match = /language-(\w+)/.exec(className || '');
                                            return !inline && match ? (
                                                <SyntaxHighlighter
                                                    style={tomorrow}
                                                    language={match[1]}
                                                    PreTag="div"
                                                    {...props}
                                                >
                                                    {String(children).replace(/\n$/, '')}
                                                </SyntaxHighlighter>
                                            ) : (
                                                <code className={className} {...props}>
                                                    {children}
                                                </code>
                                            );
                                        },
                                        table({ children }) {
                                            return <MarkdownTableWithDownload>{children}</MarkdownTableWithDownload>;
                                        },
                                        thead({ children }) {
                                            return <thead className="markdown-thead">{children}</thead>;
                                        },
                                        tbody({ children }) {
                                            return <tbody className="markdown-tbody">{children}</tbody>;
                                        },
                                        tr({ children }) {
                                            return <tr className="markdown-tr">{children}</tr>;
                                        },
                                        th({ children, style }) {
                                            return (
                                                <th className="markdown-th" style={style}>
                                                    {children}
                                                </th>
                                            );
                                        },
                                        td({ children, style }) {
                                            return (
                                                <td className="markdown-td" style={style}>
                                                    {children}
                                                </td>
                                            );
                                        },
                                        h1: ({ children }) => <h1 style={{ color: '#333', marginBottom: '10px' }}>{children}</h1>,
                                        h2: ({ children }) => <h2 style={{ color: '#555', marginBottom: '8px' }}>{children}</h2>,
                                        h3: ({ children }) => <h3 style={{ color: '#777', marginBottom: '6px' }}>{children}</h3>,
                                        p: ({ children }) => <p style={{ marginBottom: '10px', lineHeight: '1.6' }}>{children}</p>,
                                        ul: ({ children }) => <ul style={{ marginLeft: '20px', marginBottom: '10px' }}>{children}</ul>,
                                        ol: ({ children }) => <ol style={{ marginLeft: '20px', marginBottom: '10px' }}>{children}</ol>,
                                        li: ({ children }) => <li style={{ marginBottom: '5px' }}>{children}</li>,
                                        blockquote: ({ children }) => (
                                            <blockquote style={{
                                                borderLeft: '4px solid #ddd',
                                                paddingLeft: '15px',
                                                margin: '10px 0',
                                                fontStyle: 'italic',
                                                color: '#666'
                                            }}>
                                                {children}
                                            </blockquote>
                                        )
                                    }}
                                >
                                    {responseBedrock}
                                </ReactMarkdown>
                            </div>
                        ),
                        temp: false,
                        isPreviewMessage: false
                    } : msg
                );
            });

            setTimeout(() => {
                scrollToBottom();
            }, 300);

        } catch (error) {
            console.error('Error fetching data:', error);

            isStreamingRef.current = false;
            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current);
                animationFrameRef.current = null;
            }

            try {
                const claudeSuggestions = await consultClaude(
                    message,
                    `Error técnico: ${error.message || "Error de conexión"}`
                );

                const errorMessage = claudeSuggestions
                    ? `Hubo un problema con la conexión. Alternativas:\n\n${claudeSuggestions}`
                    : "Hubo un problema con la conexión. Intenta con otra consulta.";

                setMessages(prevMessages => {
                    const filteredMessages = prevMessages.filter(msg =>
                        !(msg.isPreviewMessage && (msg.id === firstAgentMessageId))
                    );

                    return filteredMessages.map(msg =>
                        msg.id === bedrockMessageId ? {
                            ...msg,
                            content: errorMessage,
                            temp: false,
                            isPreviewMessage: false
                        } : msg
                    );
                });
            } catch (claudeError) {
                setMessages(prevMessages => {
                    const filteredMessages = prevMessages.filter(msg =>
                        !(msg.isPreviewMessage && (msg.id === firstAgentMessageId))
                    );

                    return filteredMessages.map(msg =>
                        msg.id === bedrockMessageId ? {
                            ...msg,
                            content: "Hubo un problema con la conexión. Intenta con otra consulta.",
                            temp: false,
                            isPreviewMessage: false
                        } : msg
                    );
                });
            }
        }
    };

    // Interfaz (resto del código sin cambios)
    return (
        <div className="chat-container">
            <div className="messages-box">
                <ul className="messages-list">
                    {messages.map((msg, index) => (
                        <li key={index} className={`message ${msg.author === 'Bot' ? 'received' : 'sent'}`}>
                            <div className="message-text">
                                {msg.author === 'Bot' && <img src={botIcon} alt="Bot Icon" className="bot-icon" />}
                                <div className="message-content">
                                    <div className={hoverButtonIndex === index ? "pre-with-padding" : ""}>
                                        {typeof msg.content === 'string' ? (
                                            <ReactMarkdown
                                                remarkPlugins={[remarkGfm]}
                                                components={{
                                                    code({ node, inline, className, children, ...props }) {
                                                        const match = /language-(\w+)/.exec(className || '');
                                                        return !inline && match ? (
                                                            <SyntaxHighlighter
                                                                style={tomorrow}
                                                                language={match[1]}
                                                                PreTag="div"
                                                                {...props}
                                                            >
                                                                {String(children).replace(/\n$/, '')}
                                                            </SyntaxHighlighter>
                                                        ) : (
                                                            <code className={className} {...props}>
                                                                {children}
                                                            </code>
                                                        );
                                                    },
                                                    table({ children }) {
                                                        return <MarkdownTableWithDownload>{children}</MarkdownTableWithDownload>;
                                                    },
                                                    thead({ children }) {
                                                        return <thead className="markdown-thead">{children}</thead>;
                                                    },
                                                    tbody({ children }) {
                                                        return <tbody className="markdown-tbody">{children}</tbody>;
                                                    },
                                                    tr({ children }) {
                                                        return <tr className="markdown-tr">{children}</tr>;
                                                    },
                                                    th({ children, style }) {
                                                        return (
                                                            <th className="markdown-th" style={style}>
                                                                {children}
                                                            </th>
                                                        );
                                                    },
                                                    td({ children, style }) {
                                                        return (
                                                            <td className="markdown-td" style={style}>
                                                                {children}
                                                            </td>
                                                        );
                                                    },
                                                    h1: ({ children }) => <h1 style={{ color: '#333', marginBottom: '10px' }}>{children}</h1>,
                                                    h2: ({ children }) => <h2 style={{ color: '#555', marginBottom: '8px' }}>{children}</h2>,
                                                    h3: ({ children }) => <h3 style={{ color: '#777', marginBottom: '6px' }}>{children}</h3>,
                                                    p: ({ children }) => <p style={{ marginBottom: '10px', lineHeight: '1.6' }}>{children}</p>,
                                                    ul: ({ children }) => <ul style={{ marginLeft: '20px', marginBottom: '10px' }}>{children}</ul>,
                                                    ol: ({ children }) => <ol style={{ marginLeft: '20px', marginBottom: '10px' }}>{children}</ol>,
                                                    li: ({ children }) => <li style={{ marginBottom: '5px' }}>{children}</li>,
                                                    blockquote: ({ children }) => (
                                                        <blockquote style={{
                                                            borderLeft: '4px solid #ddd',
                                                            paddingLeft: '15px',
                                                            margin: '10px 0',
                                                            fontStyle: 'italic',
                                                            color: '#666'
                                                        }}>
                                                            {children}
                                                        </blockquote>
                                                    )
                                                }}
                                            >
                                                {msg.content}
                                            </ReactMarkdown>
                                        ) : (
                                            msg.content
                                        )}
                                    </div>

                                    {msg.author === 'Bot' && !msg.temp && !msg.isPreviewMessage && (
                                        <button
                                            onClick={() => handleViz(msg.id_message)}
                                            className="btn btn-visualize"
                                            disabled={vizLoading[msg.id_message]}
                                        >
                                            {vizLoading[msg.id_message] ? (
                                                <><FaSpinner className="fa-spin" style={{ marginRight: "5px" }} /> Cargando datos...</>
                                            ) : (
                                                <><FaChartLine style={{ marginRight: "5px" }} /> Visualizar Datos</>
                                            )}
                                        </button>
                                    )}

                                    {msg.author === 'Client' && (
                                        <div className="message-options-container">
                                            <button
                                                className="message-options-btn"
                                                onClick={(e) => handleOptionsClick(index, e)}
                                                onMouseEnter={() => handleButtonMouseEnter(index)}
                                                onMouseLeave={handleButtonMouseLeave}
                                                title="Opciones"
                                            >
                                                <FaEllipsisV size={14} />
                                            </button>

                                            {activeOptionsMenu === index && (
                                                <div className="message-options-menu" onClick={(e) => e.stopPropagation()}>
                                                    <button
                                                        className="message-option-item"
                                                        onClick={() => handleSaveConsult(msg.content)}
                                                        disabled={savingConsult}
                                                    >
                                                        {savingConsult ? (
                                                            <><FaSpinner className="fa-spin" style={{ marginRight: "5px" }} /> Guardando...</>
                                                        ) : (
                                                            <><FaBookmark style={{ marginRight: "5px" }} /> Guardar consulta</>
                                                        )}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </li>
                    ))}

                    {/* 💭 THINKING MESSAGE */}
                    {showThinking && thinkingMessage && (
                        <li className="message received thinking-message">
                            <div className="message-text">
                                <img src={botIcon} alt="Bot Icon" className="bot-icon" />
                                <div className="message-content thinking-content">
                                    <div className="thinking-label">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14" className="thinking-icon">
                                            <circle cx="12" cy="12" r="10" />
                                            <path d="M12 6v6l4 2" />
                                        </svg>
                                        <span>Analizando...</span>
                                    </div>
                                    <div className="thinking-text">
                                        <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                            {thinkingMessage}
                                        </ReactMarkdown>
                                    </div>
                                </div>
                            </div>
                        </li>
                    )}
                </ul>
                <div ref={messagesEndRef} />
            </div>

            <div className={`form-container`}>
                <div className="suggested-questions-carousel-container">
                    <div className="suggested-questions-carousel" ref={carouselRef}>
                        {loadingSuggestions ? (
                            <div className="loading-suggestions">
                                <FaSpinner className="fa-spin" style={{ marginRight: "5px" }} />
                                Generando sugerencias...
                            </div>
                        ) : (
                            <div className="carousel-track">
                                {suggestedQuestions.map((question, idx) => (
                                    <div
                                        key={idx}
                                        className="suggested-question"
                                        onClick={() => handleSuggestedQuestion(question)}
                                    >
                                        {question}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                <form className="message-form" onSubmit={handleSubmit}>
                    {/* 📁 FILE UPLOADER integrado en el formulario */}
                    <FileUploader
                        onFileUpload={handleFileUpload}
                        disabled={loading}
                        clearTrigger={fileClearTrigger}
                    />

                    <div className="agent-selector-container">
                        <button
                            type="button"
                            onClick={() => setAgentType(agentType === 'subnacional' ? 'nacional' : 'subnacional')}
                            className={`btn btn-agent-selector ${agentType === 'nacional' ? 'nacional' : 'subnacional'}`}
                            title={agentType === 'subnacional' ? 'Agente Subnacional (gps_full, ddd_full)' : 'Agente Nacional (channel_data, medical_data, pm_data, nps_data)'}
                        >
                            {agentType === 'subnacional' ? '📍 Sub' : '🇲🇽 Nac'}
                        </button>
                    </div>

                    <button
                        type="button"
                        onClick={toggleWebSearch}
                        className={`btn btn-web-search ${webSearchEnabled ? 'active' : ''}`}
                        title={webSearchEnabled ? 'Búsqueda web activada' : 'Activar búsqueda web'}
                        disabled={webSearchLoading}
                    >
                        {webSearchLoading ? <FaSpinner className="fa-spin" /> :
                            webSearchEnabled ? <FaGlobeAmericas /> : <FaGlobe />}
                    </button>

                    <textarea
                        ref={messageInputRef}
                        className="message-input"
                        placeholder="Escribe tu consulta..."
                        value={message}
                        onChange={handleTextareaChange}
                        rows={1}
                        onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSubmit(e); } }}
                    />

                    <button type="submit" className="btn btn-send"><FaArrowUp /></button>
                </form>

                {webSearchEnabled && (
                    <div className="web-search-indicator">
                        <FaGlobe style={{ marginRight: "5px" }} />
                        Búsqueda web activada - Se consultará información actualizada antes del análisis
                    </div>
                )}

                <p className="disclaimer">
                    Aunque analizo datos rápidamente, la decisión final es tuya. <br />
                    Mis sugerencias son solo orientativas, revisa cuidadosamente antes de actuar.
                </p>
            </div>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => setModalIsOpen(false)}
                contentLabel="Data Visualization Modal"
                className="custom-modal"
                overlayClassName="custom-overlay"
            >
                <div className="modal-content">
                    <h2 style={{ margin: "0", padding: "0" }}>Data Visualization</h2>

                    {loading ? (
                        <div className="loader-container">
                            <div className="loader"></div>
                            <p>Cargando datos, por favor espera...</p>
                        </div>
                    ) : (
                        <>
                            {queryData && (
                                <ChartWithControls
                                    columns={queryData.columns || []}
                                    data={queryData.data || []}
                                    column_types={queryData.column_types || {}}
                                    hasError={queryData.hasError || false}
                                    error={queryData.error || null}
                                />
                            )}

                            {queryData && queryData.data && !queryData.hasError && !queryData.error && (
                                <div style={{ textAlign: 'right', marginBottom: '10px', display: "flex", justifyContent: "end" }}>
                                    <button onClick={handleGenerateExcel} className="btn btn-excel">
                                        <FaFileExcel /> Descargar Excel
                                    </button>
                                </div>
                            )}

                            {queryData && queryData.data && Array.isArray(queryData.data) &&
                                queryData.data.length > 0 && !queryData.hasError && !queryData.error && (
                                    <DataTable columns={queryData.columns || []} data={queryData.data || []} />
                                )}
                        </>
                    )}
                </div>
            </Modal>
        </div>
    );
};

export default Chatbotui;